import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Steps } from "primereact/steps";
import { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router";
import ApiService from "../service/apiService";
import { Link } from "react-router-dom";
import { Avatar } from "primereact/avatar";

//kyc imports
import { useDispatch, useSelector } from "react-redux";
import { NextButton, PrevButton } from "./kycSidebar";
import { SaveButton } from "./declerationDetails";
import ApiBaseURLProps from "../other/apiBaseURL";
import { useToast } from "../other/Toast";

//import {CaptureFinger} from "./mfs100-9.0.2.6";
import axios from "axios";

import React from "react";
import { useTranslation } from "react-i18next";
import { RadioButton } from "primereact/radiobutton";
import { Controller, useForm } from "react-hook-form";
import FileUploadComponent from "../other/fileUploadComponent";
import { FileUpload } from "primereact/fileupload";
import { Toast } from "primereact/toast";
import { staticDataInKb } from "../../helper/helper";

const BiometricsComponent = (props) => {
    const { t, i18n } = useTranslation();
    const dispatch = useDispatch();
    const {
        control,
        formState: { errors },
        handleSubmit,
        reset,
    } = useForm({});
    const toast = useToast();

    //Signature


    const onSelectFile = (e) => {
        if (!e.files || e.files.length === 0) {
            dispatch(props.setBiometricsImage(undefined));
            return;
        }
        // dispatch(
        // 	props.setBiometricsImage(e.target.files[0]);
        // );
        let reader = new FileReader();
        reader.readAsDataURL(e.files[0]);
        reader.onload = function () {
            dispatch(props.setBiometricsImage(reader.result));
        };
        reader.onerror = function (error) {

            toast.error("Message", "File Not Uploaded");

        };
        //console.log(e.target.files[0]);
        e.options.clear()
    };
    return (
        <div>
            <Toast ref={toast}></Toast>
            <div className="p-grid p-fluid" id="container">
                <div
                    className="p-field p-col-12 p-md-12"
                    style={{
                        display: "flex",
                        placeItems: "center",
                        justifyContent: "center",
                        flexDirection: "column",
                    }} >
                    <h4 className="p-col-12 p-md-12">


                        <div className="p-inputgroup">
                            <img
                                height={"125px"}
                                style={{ padding: 5, paddingLeft: 10 }}
                                src={props.biometricsSli ? props.biometricsSli : "/signatureCancel.png"}
                            />
                            <div id="body" className="p-md-2 ml-3"></div>
                        </div>


                        <div className="p-inputgroup" style={{ display: 'flex', justifyContent: 'center' }}>
                            <FileUpload
                                mode="basic"
                                auto
                                maxFileSize={staticDataInKb.biometrics * 1024}
                                accept={"image/*"}
                                customUpload
                                uploadHandler={onSelectFile}

                                onValidationFail={(e) => {

                                    toast.error("Message", "File size must be less than " + staticDataInKb.biometrics + " KB.");

                                }}
                                onError={(e) => {

                                    toast.error("Message", "File Not Uploaded");

                                }}
                            />
                        </div>

                        <span style={{ color: "red" }}>{props.error}</span>
                    </h4>
                </div>
            </div>
        </div>
    );
};

export default BiometricsComponent;
